import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full bg-brand-black my-auto px-4 pt-14 z-50" }
const _hoisted_2 = { class: "flex flex-col space-y-6" }
const _hoisted_3 = { class: "flex flex-col space-y-2" }
const _hoisted_4 = { class: "flex m-auto space-x-2.5" }
const _hoisted_5 = { class: "my-auto pt-0.5" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_field = _resolveComponent("input-field")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex flex-col w-full space-y-2" }, [
                _createElementVNode("div", { class: "flex text-white text-2xl font-medium" }, "Create your password")
              ], -1)),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_input_field, {
                  modelValue: _ctx.form.password,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.password) = $event)),
                  type: "password",
                  placeholder: "Create password"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_input_field, {
                  error: _ctx.errors && _ctx.errors['password'] ? _ctx.errors['password'][0] : undefined,
                  modelValue: _ctx.form.password_confirmation,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.password_confirmation) = $event)),
                  type: "password",
                  onOnKeyEnter: _ctx.setPassword,
                  placeholder: "Confirm password"
                }, null, 8, ["error", "modelValue", "onOnKeyEnter"])
              ])
            ]),
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.setPassword && _ctx.setPassword(...args))),
              class: _normalizeClass([{
              'bg-opacity-40' : !_ctx.canSetPassword
            }, "mt-10 flex w-full bg-brand-lime rounded-full px-8 h-14 font-medium text-xl text-brand-black transition-all"])
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  (!_ctx.busy)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Continue"))
                    : _createCommentVNode("", true),
                  (_ctx.busy)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[4] || (_cache[4] = [
                        _createElementVNode("svg", {
                          class: "animate-spin h-5 w-5 text-brand-black",
                          xmlns: "http://www.w3.org/2000/svg",
                          fill: "none",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("circle", {
                            class: "opacity-25",
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: "currentColor",
                            "stroke-width": "4"
                          }),
                          _createElementVNode("path", {
                            class: "opacity-75",
                            fill: "currentColor",
                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          })
                        ], -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 2)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}